import { CSSProperties } from "react";
import { ThemeStyle } from "../../hooks/useTheme";
import { Colors } from "../../utils/colors";

type CollectedByDefaultBannerProps = {
  theme: ThemeStyle;
  style?: CSSProperties;
};

const CollectedByDefaultBanner = (props: CollectedByDefaultBannerProps) => {
  const { theme, style } = props;

  return (
    <div
      className="ColumnNormal"
      style={{
        gap: 4,
        padding: 14,
        borderRadius: 12,
        border: `0.5px solid ${
          theme?.EditableTextFieldBorder.borderColor || Colors.GRAY2
        }`,
        backgroundColor: theme.NewPrimaryBG.backgroundColor,
        ...style,
      }}
    >
      <span className="bodyMedium" style={theme.PrimaryText}>
        Name and Phone Number are Collected Automatically
      </span>
      <span className="smallBodySubtext" style={theme.SubText}>
        These are collected by default. Only add questions for anything extra.
      </span>
    </div>
  );
};

export default CollectedByDefaultBanner;
